const Visualizar = () => import('@/domains/notas_fiscais/auxiliares/ncm/views/Visualizar')
const Listar = () => import('@/domains/notas_fiscais/auxiliares/ncm/views/Listar')
const Editar = () => import('@/domains/notas_fiscais/auxiliares/ncm/views/Editar')
const Adicionar = () => import('@/domains/notas_fiscais/auxiliares/ncm/views/Adicionar')

const routes = [
    {
        name: 'listarNcmTributacoesEmissor',
        path: '/emissor/ncm',
        alias: ['/emissor/ncm/index'],
        component: Listar
    },
    {
        name: 'visualizarNcmTributacaoEmissor',        
        path: '/emissor/ncm/visualizar/:id',
        component: Visualizar
    },
    {
        name: 'adicionarNcmTributacaoEmissor', 
        path: '/emissor/ncm/adicionar',
        component: Adicionar
    },
    {
        name: 'editarNcmTributacaoEmissor',      
        path: '/emissor/ncm/editar/:id',
        component: Editar
    },
]

export default routes
